module.exports = __webpack_public_path__ + "img/ad1.d190587a.png";